<template>
    <div :id="showInModal!='1'?'page':''">
        <div :class="{'pageContent':showInModal!='1'}">
            <div class="page-title page-title-small" v-if="this.showInModal!='1'">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ویرایش موقعیت </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100" v-if="this.showInModal!='1'">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>
            <div :class="{'card card-style':showInModal!='1'}">
                <div class="content mb-0">

                    <div>
                        <p class="text-danger" v-if="v$.userPresenceModel.mapLocation.required.$invalid && v$.userPresenceModel.mapLocation.$dirty">موقعیت جغرافیایی مشخص نشده است.</p>
                    </div>

                    <div class="mb-4" v-if="this.showInModal!='1'">
                        <l-map style="height:300px" :zoom="16" :center="mapLocationObject" v-if="mapLocationObject!=null">
                            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                            <l-marker :lat-lng="mapLocationObject"></l-marker>
                        </l-map>
                    </div>

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-calendar brand-color"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : userPresenceModel.presenceDate!==null}">تاریخ </span>
                        <input type="text"
                               class="form-control ltr d-inline-block"
                               v-model="userPresenceModel.presenceDate"
                               id="endDT" :readOnly="this.showInModal=='1'" />
                    </div>



                    <div class="input-style input-style-2 has-icon input-required" v-if="this.showInModal!='1'">
                        <i class="input-icon fa fa-file-alt brand-color"></i>
                        <span class="color-highlight input-style-1-active">نوع </span>
                        <select class="form-control" type="text" v-model="userPresenceModel.userPresenceTypeId" @change="setTitle" :readOnly="this.showInModal=='1'">
                            <option value=0>ثبت موقعیت</option>
                            <option value=1>ورود</option>
                            <option value=2>خروج</option>

                        </select>

                    </div>
                    <div class="input-style input-style-2 has-icon input-required" v-else>
                        <i class="input-icon fa fa-check brand-color"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : userPresenceModel.userPresenceTypeId!==null}">نوع</span>
                        <input v-if="userPresenceModel.userPresenceTypeId==1" class="form-control" type="text" value="ورود" readonly="true">
                        <input v-if="userPresenceModel.userPresenceTypeId==2" class="form-control" type="text" value="خروج" readonly="true">
                        <input v-if="userPresenceModel.userPresenceTypeId==0" class="form-control" type="text" value="ثبت موقعیت" readonly="true">

                    </div>

                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check brand-color"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : userPresenceModel.title!==null}">عنوان</span>
                        <input class="form-control" type="text" v-model="userPresenceModel.title" @input="v$.userPresenceModel.title.$touch()" :class="{invalid:v$.userPresenceModel.title.$error}" :readOnly="this.showInModal=='1'">
                        <p class="text-danger" v-if="v$.userPresenceModel.title.required.$invalid && v$.userPresenceModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
                    </div>
                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check brand-color"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : userPresenceModel.taskWorkFullTitle!==null}">مربوط به پیگیری</span>
                        <input class="form-control" type="text" v-model="userPresenceModel.taskWorkFullTitle" readonly>
                    </div>
                    <div class="input-style input-style-2 has-icon input-required">
                        <i class="input-icon fa fa-check brand-color"></i>
                        <span class="color-highlight"  :class="{'input-style-1-active' : userPresenceModel.otherWorkFullTitle!==null}">مربوط به فعالیت</span>
                        <input class="form-control" type="text" v-model="userPresenceModel.otherWorkFullTitle" readonly>
                    </div>
                    <div class="input-style input-style-2 has-icon input-required position-relative mb-3">
                        <i class="input-icon fa fa-check brand-color"></i>
                        <span class="color-highlight" :class="{'input-style-1-active' : userPresenceModel.address!==null}">نشانی</span>
                        <textarea v-model="userPresenceModel.address" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:100px" :readOnly="true"></textarea>
                    </div>
                    <button type="button" class="btn btn-xxs mt-3 mb-3 btn-full bg-green2-dark rounded-sm font-900 w-100" @click="showMapLocation()"><i class="fa fa-map-marked font-10 ml-2"></i>نمایش موقعیت روی نقشه</button>

                    <div class="card mx-0 mb-3">
                        <!--<div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
                            <button data-toggle="collapse" data-target="#collapse-description">
                                <i class="fa fa-edit mt-2"></i>
                                <span>توضیحات</span>
                                <i class="fa fa-angle-down"></i>
                            </button>
                        </div>-->
                        <div>
                            <textarea v-model="userPresenceModel.description" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px" :readOnly="this.showInModal=='1'" placeholder="توضیحات"></textarea>
                            <button class="btn btn-link speechToTextBtn mb-3" @pointerdown="startR"
                                    @pointerup="stopR">
                                <span :class="btnRecord">
                                    <span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
                                </span>
                                <img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
                            </button>

                        </div>
                    </div>

                    <att-list  :docId="0" v-if="userPresenceModel.userPresenceId!=0" v-bind:destination="'UserPresence'" @setAttList="SetAttList($event)" :canAdd="userPresenceModel.canEdit && this.showInModal!='1'" :canDelete="userPresenceModel.canEdit && this.showInModal!='1'" :oldAttList="userPresenceModel.attList" :hasLocation="false"></att-list>

                    <button v-if="userPresenceModel.canEdit && this.showInModal!='1'" type="button" :disabled="Loading || attInProgress" class="btn btn-xxs mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateUserPresence">
                        <i class="fa fa-check font-10 ml-2"></i>
                        ثبت
                    </button>
                </div>
            </div>
        </div>
        <date-picker v-if="this.showInModal!='1'" type="date" v-model="userPresenceModel.presenceDate" format="jYYYY/jMM/jDD" element="endDT" />

        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
                <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
            </div>
        </transition>

    </div>
</template>
<script>
    import useVuelidate from '@vuelidate/core'
    import {
        required
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import { maska } from 'maska'
    import AttList from '../Components/AttList.vue';
    import DatePicker from 'vue3-persian-datetime-picker';

    import { LMap, LMarker, LTileLayer } from "@vue-leaflet/vue-leaflet";
    import "leaflet/dist/leaflet.css"
    //import L from 'leaflet';

    import { Device } from '@capacitor/device';


    import { Geolocation } from "@capacitor/geolocation";
    import { latLng } from "leaflet";
    //import 'cordova-plugin-request-location-accuracy';
    //import { AndroidPermissions } from '@ionic-native/android-permissions';
    //import { LocationAccuracy } from '@ionic-native/location-accuracy';
    //import { Capacitor } from "@capacitor/core";

    import { Icon } from 'leaflet';
    import VueSimpleAlert from 'vue3-simple-alert';

    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition 
    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });

    export default {
        components: {
            DatePicker,
            "att-list": AttList,
            "l-map": LMap,
            "l-tile-layer": LTileLayer,
            "l-marker": LMarker
        },
        setup: () => ({ v$: useVuelidate() }),
        props: ['showInModal', 'selectedUserPrecenceId'],
        data() {
            return {
                attInProgress: false,
                modified: false,
                logDeviceInfo: null,
                userPresenceId: 0,
                mapLocationObject: null,
                showType: false,
                sr: null,
                btnRecord: "btn btn-danger speechToTextBtn-i",
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                userPresenceModel: {
                    title: null,
                    userPresenceId: 0,
                    userId: 0,
                    description: " ",
                    createDateTime: null,
                    attList: [],
                    presenceDate: null,
                    mapLocation: null,
                    countryTitle: null,
                    cityTitle: null,
                    address: null,
                    goBack: true,
                    ipAddress: null,
                    deviceInfo: " ",
                    userPresenceTypeId: 0,
                    taskWorkFullTitle: "",
                    otherWorkFullTitle: "",
                    canEdit: false
                },

            };
        },
        computed: {
            Loading() {
                return this.$store.getters.GetLoading;
            },
            propsToWatch() {
                return `${this.userPresenceModel.title}|${this.userPresenceModel.description}`;
            },

        },

        created() {
            if (this.selectedUserPrecenceId != null) {
                this.userPresenceId = this.selectedUserPrecenceId;
            }
            else {
                this.userPresenceId = this.$route.params.userPresenceId;
            }
            this.GetUserPresenceItem();
            this.getServerDateTime();
            this.GetDeficeInfo();
        },
        methods: {
            startR() {
                try {
                    this.sr.start();
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                } catch (error) {
                    console.error(error);
                    this.showType = true;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },
            stopR() {
                try {
                    this.sr.stop();
                    this.showType = false;
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                } catch (error) {
                    console.error(error);
                    this.showType = false;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },

            CreateUserPresence() {
                this.v$.$touch(); //it will validate all fields
                if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
                    this.modified = false;
                    this.$store.dispatch("CreateUserPresence", this.userPresenceModel);
                    this.modified = false;
                }

            },
            async getCurrentPosition() {
                const coordinates = await Geolocation.getCurrentPosition();
                console.log(coordinates.coords.latitude);
                this.userPresenceModel.mapLocation = coordinates.coords.latitude + "," + coordinates.coords.longitude;
                this.mapLocationObject = latLng(coordinates.coords.latitude, coordinates.coords.longitude);
            },
            async GetDeficeInfo() {
                this.logDeviceInfo = await Device.getInfo();
                console.log(this.logDeviceInfo);
                this.userPresenceModel.deviceInfo = this.logDeviceInfo.model + " " + this.logDeviceInfo.platform + " " + this.logDeviceInfo.operatingSystem + " " + this.logDeviceInfo.osVersion + " " + this.logDeviceInfo.webViewVersion;

            },
            getServerDateTime() {
                this.$http.get("Task/GetServerDateTime")
                    .then(data => {
                        this.userPresenceModel.presenceDate = data.data.split("_")[0];
                        this.userPresenceModel.createDateTime = data.data.replace("_", " ");

                    });

            },
            GetUserPresenceItem() {
                this.$http.get("UserPresence/GetUserPresenceItem?id=" + this.userPresenceId)
                    .then(data => {
                        this.userPresenceModel = data.data;
                        this.modified = false
                        var m = data.data.mapLocation.split(',');
                        this.mapLocationObject = latLng(m[0], m[1]);
                    });
            },
            SetAttList(e) {
                console.log(e);
                this.userPresenceModel.attList = e;
            },
            AttInProgress(e) {
                this.attInProgress = e;
            },
            setTitle() {
                if (this.userPresenceModel.userPresenceTypeId == 1) {
                    this.userPresenceModel.title = "ورود";
                }
                else if (this.userPresenceModel.userPresenceTypeId == 2) {
                    this.userPresenceModel.title = "خروج";
                }
                else {
                    this.userPresenceModel.title = "";
                }
            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
            showMapLocation() {
                // If it's an iPhone..
                if ((navigator.platform.indexOf("iPhone") != -1)
                    || (navigator.platform.indexOf("iPod") != -1)
                    || (navigator.platform.indexOf("iPad") != -1))
                    window.open("maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" + this.userPresenceModel.mapLocation);
                else
                    window.open("https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=" + this.userPresenceModel.mapLocation);
            }
        },
        mounted() {
            try {
                this.sr = new Recognition()
                this.sr.continuous = true
                this.sr.interimResults = true
                this.sr.lang = 'fa-IR';
                var rest = "";
                this.sr.onstart = () => {
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                }
                this.sr.onresult = (evt) => {
                    rest = evt.results[evt.results.length - 1][0].transcript;
                }
                this.sr.onend = () => {
                    rest = rest.replaceAll("علامت سوال", "؟");
                    rest = rest.replaceAll("علامت تعجب", "!");
                    rest = rest.replaceAll("علامت بزرگتر", ">");
                    rest = rest.replaceAll("علامت کوچکتر", "<");
                    rest = rest.replaceAll("پرانتز باز", "(");
                    rest = rest.replaceAll("پرانتز بسته", ")");
                    rest = rest.replaceAll("شارپ", "#");
                    rest = rest.replaceAll("ستاره", "*");
                    rest = rest.replaceAll("دو نقطه", ": ");
                    rest = rest.replaceAll("نقطه ویرگول", "; ");
                    rest = rest.replaceAll("نقطه", ". ");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("پاراگراف جدید", "\n");
                    rest = rest.replaceAll("پاراگراف بعد", "\n");
                    rest = rest.replaceAll("پاراگراف بعدی", "\n");
                    rest = rest.replaceAll("پاراگراف", "\n");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("خط بعدی", "\n");
                    rest = rest.replaceAll("خط بعد", "\n");
                    rest = rest.replaceAll("خط جدید", "\n");

                    if (this.userPresenceModel.description == null || this.userPresenceModel.description == "null")
                        this.userPresenceModel.description = "";
                    if (rest != null && rest != '')
                        this.userPresenceModel.description = this.userPresenceModel.description + " " + rest
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                    rest = "";
                    this.showType = false;
                }
            } catch (error) {
                console.error(error);
                // Expected output: ReferenceError: nonExistentFunction is not defined
                // (Note: the exact output may be browser-dependent)
            }

            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        },
        validations: {
            userPresenceModel: {
                title: {
                    required,
                },
                presenceDate: {
                    required
                },
                mapLocation: {
                    required
                }
            }


        },
        directives: { maska },
        beforeRouteLeave(to, from, next) {
            if (this.modified == true) {
                VueSimpleAlert.fire({
                    title: 'با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟',
                    showCancelButton: true,
                    confirmButtonText: 'تأیید',
                    cancelButtonText: `انصراف`,
                }).then((result) => {
                    console.log(this.modified);

                    if (result.value == true) {
                        next();
                    } else {
                        next(false);
                    }
                })
            }
            else {
                next();
            }
        }

    };
</script>
